//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from "../src/common/helpers/HttpHelper";
import environments from "../src/common/environments/environment";
const http = new httpHelper();

export const CandidatePageActions = {
  GetProgramStatus: getProgramStatus,
  GetRTPersona: getRTPersona,
  GetCascadeClientData: getCascadeClientData,
  GetRTProgramClass: getRTProgramClass,
  GetRTProgramTemplate: getRTProgramTemplate,
  GetServiceOffice: getServiceOffice,
  GetCountriesList: getCountriesList,
  GetRightOfficeId: getRightOfficeId,
  GetGenericAccountByRefCode: getGenericAccountByRefCode,
  GetAllGenericAccount: getAllGenericAccount,
  UpdateGenericAccount: updateGenericAccount,
  GetRolePermissions: getRolePermissions,
  GetCandidateDetailsByRefCode: getCandidateDetailsByRefCode,
  DeleteGenericAccount: deleteGenericAccount,
  GetLogo: getLogo,
  AddGenericAccount: addGenericAccount,
  GetAllUsersEmail: getAllUsersEmail,
  getAdminCandidateCMSContent: getAdminCandidateCMSContent,
};

function getProgramStatus() {
  return http.get(environments.PROGRAM_STATUS);
}

function getAllUsersEmail() {
  return http.adminGet(environments.USERS);
}

function getRTPersona() {
  return http.get(environments.RT_PERSONA);
}

function getCascadeClientData() {
  return http.candidateGet(environments.CascadingClientSpecificData);
}

function getGenericAccountByRefCode(refCode) {
  let refGenericAccByRefCode = environments.GET_GENERIC_ACCOUNT.replace(
    "{ReferenceCode}",
    refCode
  );
  return http.adminGet(refGenericAccByRefCode);
}

function getCandidateDetailsByRefCode(refCode) {
  let refCandidateDetailsByRefCode =
    environments.GET_CANDIDATE_ADMIN_DETAILS.replace(
      "{ReferenceCode}",
      refCode
    );
  return http.canDetailsGet(refCandidateDetailsByRefCode);
}

function updateGenericAccount(payload) {
  return http.adminPut(environments.UPDATE_GENERIC_ACCOUNT, payload);
}

function addGenericAccount(payload) {
  return http.adminPost(environments.ADD_GENERIC_ACCOUNT, payload);
}

function deleteGenericAccount(refCode) {
  let refDeleteGenericAcc = environments.DELETE_GENERIC_ACCOUNT.replace(
    "{ReferenceCode}",
    refCode
  );
  return http.adminDelete(refDeleteGenericAcc);
}

function getRolePermissions() {
  let refRolePermissions = environments.GET_ROLE_PERMISSIONS;
  return http.adminGet(refRolePermissions);
}

function getAllGenericAccount() {
  return http.adminGet(environments.GET_ALL_GENERIC_ACCOUNT);
}

function getRTProgramClass() {
  return http.get(environments.RT_PROGRAM_CLASS);
}

function getRTProgramTemplate() {
  return http.get(environments.RT_PROGRAM_TEMPLATE);
}

function getCountriesList(locale, key) {
  let refCountry = environments.GET_COUNTRY_LIST.replace(
    "{locale}",
    locale
  ).replace("{key}", key);
  return http.get(refCountry);
}

function getServiceOffice(countryCode) {
  let refServiceOffice =
    environments.SERVICE_OFFICE + "?countrycode=" + countryCode;
  return http.get(refServiceOffice);
}

function getRightOfficeId(serviceOfficeID) {
  let refRightOfficeId =
    environments.RIGHT_OFFICE_ID + "?RightOfficeId=" + serviceOfficeID;
  return http.get(refRightOfficeId);
}

function getLogo() {
  return http.jsonGet(
    environments.CONTAINER_NAME + environments.ADMIN_DASHBOARD_JSON
  );
}

function getAdminCandidateCMSContent(payload) {
  return http.CMSpost(environments.ADMIN_PAGE_DETAILS, payload);
}
